module.exports = __webpack_public_path__ + "static/media/home_banner_cooperation.ba287e2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/home_banner_cooperation.png
// module id = 393
// module chunks = 0